/**
 * bh-size-guide.js — the cake Size Guide sheet's content logic.
 *
 * Data source: window.BakehuntersConfig.sizes — built server-side from the
 * `cake_size` metaobjects (bakehunters-config.liquid), so portions / diameter /
 * localized names / weight / sponge-layers all update when an admin edits the
 * metaobject. Nothing about the guide is hardcoded per-size.
 *
 * Pre-select: on open we read the live PDP selection from window.bhApp.state
 * (shape + sizeHandle) and match the guide to it. This is one-way (PDP → guide);
 * picking a size in the guide only updates the guide illustration, it does not
 * change the PDP (the guide is informational).
 *
 * Sheet open/close/backdrop/drag is the shared bh-drawer component; this file
 * only fills + reacts.
 */
(function () {
  var sheet = document.getElementById('BhSizeGuide');
  if (!sheet) return;

  var cfg = window.BakehuntersConfig || {};
  var T = cfg.t || {};
  var isEN = String(cfg.locale || 'bg').indexOf('en') === 0;
  var ALL = cfg.sizes || [];
  if (!ALL.length) return;

  var els = {
    name: sheet.querySelector('[data-bhsg-name]'),
    lede: sheet.querySelector('[data-bhsg-lede]'),
    cake: sheet.querySelector('[data-bhsg-cake]'),
    grams: sheet.querySelector('[data-bhsg-grams]'),
    selName: sheet.querySelector('[data-bhsg-selname]'),
    slices: sheet.querySelector('[data-bhsg-slices]'),
    sliceN: sheet.querySelector('[data-bhsg-slicen]'),
    list: sheet.querySelector('[data-bhsg-list]')
  };

  var state = { shape: 'round', handle: null };

  // ---- pure helpers ----
  function displayName(s) { return (isEN ? (s.nameEN || s.name) : (s.nameBG || s.name)) || s.handle; }
  function portionsHi(s) { var p = String(s.portions || '').split(/[-–]/); return parseInt(p[1] || p[0], 10) || 2; }
  // Weight + sponge layers aren't stored on the metaobject (no field yet), so derive from
  // diameter — but honour s.weightGrams / s.spongeLayers if a future admin field feeds them.
  // ponytail: derived table, not admin-editable; add a metaobject field + config wiring if that's ever needed.
  function weightG(s) { if (s.weightGrams) return +s.weightGrams; var d = +s.diameter || 0; return d >= 24 ? 2500 : d >= 22 ? 2000 : d >= 20 ? 1200 : d >= 16 ? 800 : 500; }
  function layers(s) { if (s.spongeLayers) return +s.spongeLayers; var d = +s.diameter || 0; return d >= 24 ? 4 : d < 16 ? 2 : 3; }
  function fmtWeight(g) {
    g = +g || 0;
    if (g >= 1000) return (+(g / 1000).toFixed(1)) + ' ' + (T.sizeguide_unit_kg || 'кг');
    return g + ' ' + (T.sizeguide_unit_g || 'г');
  }
  function layerWord(bl) {
    var words = String(T.sizeguide_layer_words || 'два|три|четири').split('|');
    return words[Math.max(0, Math.min(words.length - 1, bl - 2))] || String(bl);
  }
  function forShape() {
    return ALL.filter(function (s) { return (s.shape || 'round') === state.shape; })
      .sort(function (a, b) { return (a.diameter || 0) - (b.diameter || 0); });
  }

  // ---- render ----
  function renderCake(bl) {
    var c = els.cake; c.innerHTML = '';
    var top = document.createElement('i'); top.className = 'bhsg-lyr-top'; c.appendChild(top);
    for (var i = 0; i < bl; i++) {
      var sp = document.createElement('i'); sp.className = 'bhsg-lyr-sp'; c.appendChild(sp);
      if (i < bl - 1) { var fl = document.createElement('i'); fl.className = 'bhsg-lyr-fl'; c.appendChild(fl); }
    }
  }

  function renderList() {
    var el = els.list; el.innerHTML = '';
    forShape().forEach(function (s) {
      var px = Math.round(20 + ((s.diameter || 12) - 12) * 2.4); // 12cm→20px … 24cm→~49px
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bhsg-row';
      b.dataset.handle = s.handle;
      b.setAttribute('aria-pressed', s.handle === state.handle ? 'true' : 'false');
      // Heart mask lives in CSS (.bhsg-dot.is-heart) — never inline it into the style attr.
      b.innerHTML =
        '<span class="bhsg-dot' + (state.shape === 'heart' ? ' is-heart' : '') + '" style="width:' + px + 'px;height:' + px + 'px"></span>' +
        '<span class="bhsg-rmeta"><span class="bhsg-rname"></span><span class="bhsg-rspec"></span></span>' +
        '<span class="bhsg-rport"><span class="bhsg-rport-n"></span><small></small></span>';
      b.querySelector('.bhsg-rname').textContent = displayName(s);
      b.querySelector('.bhsg-rspec').textContent = (s.diameter || 0) + ' ' + (T.sizeguide_unit_cm || 'см') + ' · ' + fmtWeight(weightG(s));
      b.querySelector('.bhsg-rport-n').textContent = s.portions || '';
      b.querySelector('.bhsg-rport small').textContent = T.portions || 'парчета';
      b.addEventListener('click', function () { state.handle = s.handle; update(); });
      el.appendChild(b);
    });
  }

  function update() {
    var arr = forShape();
    var s = arr.filter(function (x) { return x.handle === state.handle; })[0] || arr[0];
    if (!s) return;
    state.handle = s.handle;

    var bl = layers(s);
    var hi = Math.min(portionsHi(s), 8);

    els.grams.textContent = fmtWeight(weightG(s));
    els.selName.textContent = displayName(s);
    els.sliceN.textContent = s.portions || '';
    els.name.textContent = displayName(s) + (T.sizeguide_title_suffix || '?');
    els.lede.textContent = (T.sizeguide_lede || 'Висока торта с {w} блата и пълнеж.').replace('{w}', layerWord(bl));

    renderCake(bl);
    els.slices.innerHTML = '';
    for (var k = 0; k < hi; k++) { var d = document.createElement('span'); d.className = 'bhsg-slice'; els.slices.appendChild(d); }

    Array.prototype.forEach.call(els.list.querySelectorAll('.bhsg-row'), function (r) {
      r.setAttribute('aria-pressed', r.dataset.handle === state.handle ? 'true' : 'false');
    });
  }

  function setShape(sh) {
    state.shape = (sh === 'heart') ? 'heart' : 'round';
    Array.prototype.forEach.call(sheet.querySelectorAll('[data-bhsg-shape]'), function (btn) {
      btn.setAttribute('aria-pressed', btn.dataset.bhsgShape === state.shape ? 'true' : 'false');
    });
    var arr = forShape();
    if (!arr.some(function (s) { return s.handle === state.handle; })) state.handle = (arr[0] || {}).handle;
    renderList();
    update();
  }

  // Match the guide to whatever the PDP configurator currently has selected.
  function syncFromPdp() {
    var st = (window.bhApp && window.bhApp.state) || {};
    if (st.shape === 'heart' || st.shape === 'round') state.shape = st.shape;
    if (st.sizeHandle && ALL.some(function (s) { return s.handle === st.sizeHandle && (s.shape || 'round') === state.shape; })) {
      state.handle = st.sizeHandle;
    }
  }

  // ---- shape toggle ----
  Array.prototype.forEach.call(sheet.querySelectorAll('[data-bhsg-shape]'), function (btn) {
    btn.addEventListener('click', function () { setShape(btn.dataset.bhsgShape); });
  });

  // Re-sync from the PDP each time the sheet is opened (bhApp exists by then even
  // if it didn't at first paint). bh-drawer opens it; we piggyback the same trigger
  // click and render synchronously so the content is ready before the sheet slides in.
  document.addEventListener('click', function (e) {
    var tr = e.target.closest && e.target.closest('[aria-controls="BhSizeGuide"]');
    if (tr) { syncFromPdp(); setShape(state.shape); }
  });

  // First paint (defaults; re-synced on open).
  syncFromPdp();
  if (!state.handle) state.handle = (forShape()[0] || {}).handle;
  setShape(state.shape);

  // ponytail: UI glue has no unit-test harness; guard a one-shot self-check behind a flag.
  if (window.BHSG_DEBUG) {
    console.assert(fmtWeight(1200) === '1.2 ' + (T.sizeguide_unit_kg || 'кг'), 'fmtWeight kg');
    console.assert(fmtWeight(500) === '500 ' + (T.sizeguide_unit_g || 'г'), 'fmtWeight g');
    console.assert(portionsHi({ portions: '2-4' }) === 4, 'portionsHi');
    console.assert(layerWord(4) === String(T.sizeguide_layer_words || 'два|три|четири').split('|')[2], 'layerWord');
  }
})();
